<template>
  <div />
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'FormBuilderProvision',
  created() {
    this.fetchJobData()
  },
  methods: {
    ...mapActions({
      fetchJobData: 'fetchJobData',
    }),
  },
}
</script>
